// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play-sample-icon {
  cursor: pointer;
  margin-left: 2px;
  margin-right: 3px;
  user-select: none;
}

.sample-library {
  display: flex;
  flex-direction: column;
  margin: 8px;
}

.sample-row {
  display: grid;
  grid-template-columns: 20px 1fr 70px 50px;

  .sample-name {
    overflow: hidden;
  }
}

.load-samples-buttons {
  display: flex;
  flex-direction: row;

  button {
    margin-right: 4px;
  }
}

.sample-search {
  margin-bottom: 6px;
  margin-top: 7px;

  input {
    margin-left: 4px;
    background: #242424;
    border: 1px solid #555;
    color: #eee;
  }
}

.sample-select-dialog-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;

  button {
    width: 150px;
    margin-right: 40px;
    margin-left: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/sampleLibrary/SampleLibraryUI/SampleLibraryUI.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yCAAyC;;EAEzC;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;;EAEf;IACE,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".play-sample-icon {\n  cursor: pointer;\n  margin-left: 2px;\n  margin-right: 3px;\n  user-select: none;\n}\n\n.sample-library {\n  display: flex;\n  flex-direction: column;\n  margin: 8px;\n}\n\n.sample-row {\n  display: grid;\n  grid-template-columns: 20px 1fr 70px 50px;\n\n  .sample-name {\n    overflow: hidden;\n  }\n}\n\n.load-samples-buttons {\n  display: flex;\n  flex-direction: row;\n\n  button {\n    margin-right: 4px;\n  }\n}\n\n.sample-search {\n  margin-bottom: 6px;\n  margin-top: 7px;\n\n  input {\n    margin-left: 4px;\n    background: #242424;\n    border: 1px solid #555;\n    color: #eee;\n  }\n}\n\n.sample-select-dialog-buttons-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  button {\n    width: 150px;\n    margin-right: 40px;\n    margin-left: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
